<template>
  <div class="shop-container">
    <div class="t">
      <div class="tl">
        <div class="tl-img">
          <i class="icon iconfont iconsuccess"></i>
        </div>
        <div class="tl-info">
          <h3 v-if="orderInfo.order_type==9&&orderInfo.customized_status==2">保证金支付成功，我们会尽快安排设计师与您联系。</h3>
          <h3 v-if="orderInfo.order_type==9&&orderInfo.customized_status==6">定制订单首付款已付，订单进入生产环节，我们会尽快生产成品，生产过程可以随时在会员中心查看。</h3>
          <h3 v-else>支付成功!</h3>
        </div>
      </div>
      <div class="tr">
        <div class="tr-btn back" @click="$router.replace('home')">回到首页</div>
        <div class="tr-btn go">
          <router-link v-if="orderInfo.order_type==9" :to="{name:'cusOrderDetail',params:{order_id:order_id}}">查看详情</router-link>
          <router-link v-else :to="{name:'orderDetail',params:{order_id:order_id}}">查看详情</router-link>
        </div>
      </div>
    </div>
    <div class="b">
      <div class="title">
        <h2>买购物车中商品的人还买了</h2>
        <ProductRowFive :list="goodsList"></ProductRowFive>
      </div>
    </div>
  </div>
</template>

<script>
import ProductRowFive from "@/components/layout/ProductRowFive.vue";
export default {
  name: "PaySuccess",
  components: {ProductRowFive},
  props: {},
  data() {
    return {
      order_id:'',
      goodsList:[],
      orderInfo:{},
    };
  },
  watch: {},
  computed: {},
  methods: {
    getPickGoods(){
      let data={
        page:1,
        limit:10
      }
      this.$api.getPickGoods(data).then(res=>{
        if(res.status){
          this.goodsList=res.data.list;
        }
      })
    },
    getOrderDetail() {
      let data = {
        order_id:this.$route.query.order_id
      };
      this.$api.orderDetail(data).then(res => {
        if (res.status) {
          this.orderInfo = Object.assign({},this.orderInfo,res.data);
        }
      });
    },
  },
  created() {
    this.getOrderDetail()
  },
  mounted() {
    let order_id = this.$route.query.order_id;
    this.order_id = order_id;
    this.getPickGoods()
  }
};
</script>
<style lang="scss" scoped>
@import "~@/assets/css/variable.scss";
.shop-container {
  padding-top: 20px;
}
.t {
  margin-bottom: 26px;
  padding: 0 0 28px 0;
  height: 68px;
  border-bottom: 1px solid #e0e0e0;
  .tl {
    .tl-img {
      float: left;
      width: 64px;
      height: 64px;
      margin-right: 20px;
      .icon {
        font-size: 64px;
        color: #84c54d;
      }
    }
    .tl-info {
      float: left;
      h3 {
        color: #424242;
        font-size: 22px;
        font-weight: normal;
        margin-top:20px;
      }
    }
  }
  .tr {
    float: right;
    .tr-btn {
      display: inline-block;
      width: 180px;
      margin-left: 12px;
      margin-top: 5px;
      height: 38px;
      line-height: 38px;
      text-align: center;
      cursor: pointer;
      -webkit-transition: all 0.4s;
      transition: all 0.4s;
      &.back {
        border: 1px solid #b0b0b0;
        color: #757575;
        &:hover {
          background: #fff;
        }
      }
      &.go {
        background: $theme-color;
        color: #fff;
        border: 1px solid $theme-color;
      }
    }
  }
}
.b {
  .title {
    h2 {
      text-align: center;
      height: 50px;
      font-size: 28px;
      font-weight: 400;
      color: #757575;
      margin-bottom:20px;
    }
  }
}
</style>